import React from "react";

const SvgBottomArrowSmall = props => <svg width={13} height={8} fill="none" {...props}><path d="M6.6 7.5c.24-.03.47-.13.65-.3l4.82-4.48c.33-.29.49-.74.41-1.19a1.22 1.22 0 0 0-.76-.96c-.4-.15-.83-.05-1.14.26L6.5 4.62 2.42.82c-.3-.3-.75-.4-1.14-.25-.4.14-.69.51-.76.96-.08.45.08.9.41 1.19L5.75 7.2c.24.22.55.33.86.3z" fill="currentColor" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/bottom-arrow-small_3b7b64.svg";
export { SvgBottomArrowSmall as ReactComponent };